import React from "react";
import { ListingInfo } from "../ui/ListingInfo";
import SafeHtmlSpan from "../ui/SafeHtmlSpan";

export const WhatsOnFilterListInfo = ({
  isLoading,
  isError,
  queryResult,
  filterData,
  term,
  id = "listing"
}: {
  isLoading: boolean;
  isError: boolean;
  queryResult: any;
  filterData: any;
  term?: any;
  id?: string;
}) => {
  return (
    <ListingInfo id={id}>
      {!isError && !isLoading && queryResult?.items?.length > 0 && (
        <>
          You are on page <b>{filterData.page}</b> of{" "}
          <b>{queryResult?.pageTotal}</b> of a listing of{" "}
          <b>{queryResult?.postTotal}</b> exhibitions and/or events
          {term?.name ? (
            <>
              {" "}
              filed under the category{" "}
              <b>
                <SafeHtmlSpan html={term?.name} />
              </b>
            </>
          ) : undefined}
          .
        </>
      )}

      {!isError && !isLoading && !queryResult?.items?.length && (
        <>We could not find anything matching your filter criteria</>
      )}

      {isError && !isLoading && <>Opps, an error happened. Please try again!</>}
      {isLoading && <>Loading data ...</>}
    </ListingInfo>
  );
};
